import { render, staticRenderFns } from "./InputIcon.vue?vue&type=template&id=21fed0a4&scoped=true&"
import script from "./InputIcon.vue?vue&type=script&lang=js&"
export * from "./InputIcon.vue?vue&type=script&lang=js&"
import style0 from "./InputIcon.vue?vue&type=style&index=0&id=21fed0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fed0a4",
  null
  
)

export default component.exports